import { createSlice, createSelector } from '@reduxjs/toolkit';
import { RootState } from './types';
interface Business {
  name: string;
  Adrress: Record<string, unknown>;
  description: string;
  /** Raw business type from the profile, e.g. "Restaurant". */
  type?: string;
}

export interface AuthSliceObject {
  inApp: {
    account: {
      businessInfo: Business;
      //type correctly as from BE
      employeeInfo: Record<string, any>;
    };
  };
  register: {
    ownerInfo: {
      username: string;
      firstName: string;
      lastName: string;
      email: string;
      phoneNumber: string;
      password: string;
      confirmPassword: string;
      termsAccepted: boolean;
      userPackage: string;
    };
    businessInfo: {
      name: string;
      type: string;
      description: string;
      county: string;
      town: string;
      postalAddress: string;
    };
    formValidation: {
      validName: boolean;
      validFirstName: boolean;
      validLastName: boolean;
      validEmail: boolean;
      validPhone: boolean;
      validPwd: boolean;
      validMatch: boolean;
      validBusinessName: boolean;
      validBusinessType: boolean;
      validCounty: boolean;
      validTown: boolean;
    };
  };
}

const initialState: AuthSliceObject = {
  inApp: {
    account: {
      businessInfo: {
        name: '',
        Adrress: {},
        description: '',
      },
      employeeInfo: {},
    },
  },
  register: {
    ownerInfo: {
      username: '',
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      password: '',
      confirmPassword: '',
      termsAccepted: false,
      userPackage: '',
    },
    businessInfo: {
      name: '',
      type: '',
      description: '',
      county: '',
      town: '',
      postalAddress: '',
    },
    formValidation: {
      validName: false,
      validFirstName: false,
      validLastName: false,
      validEmail: false,
      validPhone: false,
      validPwd: false,
      validMatch: false,
      validBusinessName: false,
      validBusinessType: false,
      validCounty: false,
      validTown: false,
    },
  },
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    addInAppBusinessInfo: (state, action) => {
      state.inApp.account.businessInfo = {
        ...state.inApp.account.businessInfo,
        ...action.payload,
      };
    },
    addInAppEmployeeInfo: (state, action) => {
      state.inApp.account.employeeInfo = {
        ...state.inApp.account.employeeInfo,
        ...action.payload,
      };
    },
    updateInAppEmployeeInfo: (state, action) => {
      state.inApp.account.employeeInfo = {
        ...state.inApp.account.employeeInfo,
        ...action.payload,
      };
    },
    setEmployeeLocalProfileImage: (state, action) => {
      state.inApp.account.employeeInfo = {
        ...state.inApp.account.employeeInfo,
        bp_employee_profile_picture_local_uri: action.payload,
      };
    },
    setEmployeeRemoteProfileImageUrl: (state, action) => {
      state.inApp.account.employeeInfo = {
        ...state.inApp.account.employeeInfo,
        bp_employee_profile_picture_url: action.payload,
      };
    },
    addRegisterOwnerInfo: (state, action) => {
      state.register.ownerInfo = {
        ...state.register.ownerInfo,
        ...action.payload,
      };
    },
    addRegisterBusinessInfo: (state, action) => {
      state.register.businessInfo = {
        ...state.register.businessInfo,
        ...action.payload,
      };
    },
    updateRegisterForm: (state, action) => {
      state.register.ownerInfo = {
        ...state.register.ownerInfo,
        ...action.payload,
      };
    },
    updateFormValidation: (state, action) => {
      state.register.formValidation = {
        ...state.register.formValidation,
        ...action.payload,
      };
    },
    updateBusinessInfo: (state, action) => {
      state.register.businessInfo = {
        ...state.register.businessInfo,
        ...action.payload,
      };
    },
    updateBusinessValidation: (state, action) => {
      state.register.formValidation = {
        ...state.register.formValidation,
        ...action.payload,
      };
    },
    clearEmployeeAndBusinessInfo: state => {
      state.inApp.account.employeeInfo = {};
      state.inApp.account.businessInfo = {
        name: '',
        Adrress: {},
        description: '',
      };
    },
  },
});

// combine all reducers that clear employee and buniess info to one action
// Plain Auth Selectors (extraction only — no createSelector for identity)
export const selectBusinessInfo = (state: RootState) =>
  state.auth.inApp.account.businessInfo;

export const selectEmployeeInfo = (state: RootState) =>
  state.auth.inApp.account.employeeInfo;

export const selectRegisterOwnerInfo = (state: RootState) =>
  state.auth.register.ownerInfo;

export const selectRegisterBusinessInfo = (state: RootState) =>
  state.auth.register.businessInfo;

export const selectFormValidation = (state: RootState) =>
  state.auth.register.formValidation;

// Derived selectors (actual transformation — createSelector is correct here)
export const selectIsFormValid = createSelector(
  [selectFormValidation],
  validation => {
    return Object.values(validation).every(field => field === true);
  },
);

export const selectBusinessName = createSelector(
  [selectBusinessInfo],
  businessInfo => businessInfo?.name || '',
);

export const selectEmployeeName = createSelector(
  [selectEmployeeInfo],
  employeeInfo => employeeInfo?.bp_employee_name || '',
);

export const {
  addInAppBusinessInfo,
  addInAppEmployeeInfo,
  updateInAppEmployeeInfo,
  setEmployeeLocalProfileImage,
  setEmployeeRemoteProfileImageUrl,
  addRegisterOwnerInfo,
  addRegisterBusinessInfo,
  updateRegisterForm,
  updateFormValidation,
  updateBusinessInfo,
  updateBusinessValidation,
  clearEmployeeAndBusinessInfo,
} = authSlice.actions;
export default authSlice.reducer;
